import { Icon } from "../../../components/icons";
import { MOCK_CATEGORIES, MOCK_ELIM_PLAYERS as P, MOCK_GROUP_A, MOCK_TOURNAMENT } from "../mockData";
import { MockFigure, PhoneFrame } from "./frames";
import "./ResultCaptureMock.css";

/**
 * M7 · Captura de resultados (escena D3 de /organizador). El celular copia la
 * hoja «Capturar resultado» de AdminTournamentSchedulePage (jugadores en
 * filas, sets en columnas, palomita del ganador, «✓ Publicar») y la tarjeta
 * de al lado usa el título y el cuerpo reales del aviso al admin de
 * `matches/result_reports.py` («Reporte de resultado pendiente»).
 */

const surname = (fullName: string): string => fullName.trim().split(/\s+/).pop() ?? fullName;

const CATEGORY = MOCK_CATEGORIES[0]; // Varonil Abierta B
const REPORTER = MOCK_GROUP_A[1].name; // Paola Méndez

/** Semifinal #1: Salazar 6-4 3-6 [10-8] Herrera (mismo marcador del cuadro). */
const SCORE_ROWS = [
  { name: P.salazar, games: [6, 3, 10], winner: true },
  { name: P.herrera, games: [4, 6, 8], winner: false },
];

const setWinner = (setIndex: number) =>
  SCORE_ROWS.reduce((best, row) => (row.games[setIndex] > best.games[setIndex] ? row : best)).name;

const BACKGROUND_ROWS = [
  { meta: "09:00 · Cancha 1 · Cuartos #1", players: `${surname(P.salazar)} vs ${surname(P.aguilar)}`, score: "6-2 6-3" },
  { meta: "09:00 · Cancha 3 · Cuartos #3", players: `${surname(P.navarro)} vs ${surname(P.pena)}`, score: "6-4 7-5" },
  // Misma semifinal que M6 movió por lluvia a las 13:30 en la Cancha 2.
  { meta: "13:30 · Cancha 2 · Semifinal #1", players: `${surname(P.salazar)} vs ${surname(P.herrera)}`, score: null },
];

const REPORT_BODY = `${REPORTER} reportó un resultado para Grupo A #2 — 6-3 6-4. Revísalo en la cola de aprobación.`;

const FIGURE_LABEL =
  `Captura de resultado desde el celular: en la Semifinal #1 de ${CATEGORY}, ${P.salazar} gana a ${P.herrera} ` +
  "6-4, 3-6 y 10-8 en súper muerte súbita. Al lado, el reporte de resultado de una jugadora pendiente de aprobar. " +
  "Al publicar, el cuadro se actualiza y la tabla se recalcula.";

export function ResultCaptureMock() {
  return (
    <MockFigure label={FIGURE_LABEL} className="mk-res-figure">
      <div className="mk-res">
        <PhoneFrame className="mk-res__phone">
          <div className="mk-res__app">
            <div className="mk-res__appbar">
              <span className="mk-res__back">‹</span>
              <div>
                <strong>Rol de juego</strong>
                <small>{MOCK_TOURNAMENT.name} · sáb 17 oct</small>
              </div>
            </div>
            {BACKGROUND_ROWS.map((row) => (
              <div key={row.meta} className="mk-res__bgrow">
                <small>{row.meta}</small>
                <div>
                  <strong>{row.players}</strong>
                  {row.score ? <span className="mk-res__bgscore">{row.score}</span> : <span className="mk-res__bgcta">Capturar resultado</span>}
                </div>
              </div>
            ))}
          </div>
          <div className="mk-res__scrim" />

          <div className="mk-res__sheet">
            <span className="mk-res__grab" />
            <div className="mk-res__head">
              <div>
                <span className="mk-res__eyebrow">Capturar resultado</span>
                <strong>Semifinal #1 · {CATEGORY}</strong>
              </div>
              <span className="mk-res__close">×</span>
            </div>

            <div className="mk-res__super">
              <span>Súper muerte súbita</span>
            </div>

            <div className="mk-res__board">
              <div className="mk-res__row mk-res__row--head">
                <span className="mk-res__corner">Jugador</span>
                <span>Set 1</span>
                <span>Set 2</span>
                <span className="mk-res__col-super">Set 3</span>
              </div>
              {SCORE_ROWS.map((row) => (
                <div key={row.name} className={`mk-res__row${row.winner ? " is-winner" : ""}`}>
                  <span className="mk-res__player">
                    <span className="mk-res__check">{row.winner ? <Icon name="check" /> : null}</span>
                    <span className="mk-res__name">{row.name}</span>
                  </span>
                  {row.games.map((value, index) => (
                    <span
                      key={index}
                      className={`mk-res__score${setWinner(index) === row.name ? " is-set-winner" : ""}${index === 2 ? " is-super" : ""}`}
                    >
                      {value}
                    </span>
                  ))}
                </div>
              ))}
            </div>

            <div className="mk-res__actions">
              <span className="mk-res__btn mk-res__btn--ghost">Cancelar</span>
              <span className="mk-res__btn mk-res__btn--lime">
                <Icon name="check" /> Publicar
              </span>
            </div>
          </div>
        </PhoneFrame>

        <div className="mk-res__side">
          <div className="mk-res__report">
            <div className="mk-res__report-head">
              <span className="mk-res__bell">
                <Icon name="bell" />
              </span>
              <strong>Reporte de resultado pendiente</strong>
              <small>ahora</small>
            </div>
            <p>{REPORT_BODY}</p>
            <div className="mk-res__report-actions">
              <span className="mk-res__btn mk-res__btn--lime">Aprobar resultado</span>
              <span className="mk-res__btn mk-res__btn--ghost">Rechazar</span>
            </div>
          </div>

          <div className="mk-res__tags">
            <span>
              <span className="mk-res__tag-check">
                <Icon name="check" />
              </span>
              Cuadro actualizado
            </span>
            <span>
              <span className="mk-res__tag-check">
                <Icon name="check" />
              </span>
              Tabla recalculada
            </span>
          </div>
        </div>
      </div>
    </MockFigure>
  );
}
